var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { classNames, tagName, attribute } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
/* eslint square/no-restricted-files:'off' -- unscoped components in this folder are discouraged */
import { isNone } from '@ember/utils';
import { scheduleOnce } from '@ember/runloop';
import Component from '@ember/component';
import Enum from '@square/dashboard-utilities/utils/enum';
import * as d3 from 'd3';
import $ from 'jquery';
const MIN_SPACE_PER_CHAR = 6;
export const RotateOptions = new Enum('NEVER', 'AUTO', 'ALWAYS');
let SqChartAxis = (_dec = classNames('chart-axis'), _dec2 = tagName('g'), _dec3 = observes('scale', 'orient', 'innerTickSize', 'outerTickSize', 'tickFormat', 'tickPadding', 'tickValues', 'ticks', 'majorInnerTickSize', 'transitionDuration', 'transitionEase', 'rotateTicksToFit'), _dec(_class = _dec2(_class = (_class2 = class SqChartAxis extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "transform", _descriptor, this);
    // bind to these from the parent chart component to configure the axis
    // these correspond to the documented getter/setters in d3.svg.axis()
    _defineProperty(this, "scale", null);
    _defineProperty(this, "orient", 'bottom');
    _defineProperty(this, "outerTickSize", 0);
    _defineProperty(this, "innerTickSize", 3);
    _defineProperty(this, "tickFormat", null);
    _defineProperty(this, "tickPadding", 6);
    _defineProperty(this, "tickValues", null);
    // either set this or set ticks, not both
    _defineProperty(this, "ticks", null);
    // custom properties, not d3 standards
    _defineProperty(this, "majorInnerTickSize", 6);
    _defineProperty(this, "transitionDuration", 0);
    _defineProperty(this, "transitionEase", 'ease-in-out');
    _defineProperty(this, "rotateTicksToFit", RotateOptions.NEVER);
  }
  init(...args) {
    super.init(...args);
    this._scaleChanged();
  }

  // eslint-disable-next-line ember/no-observers
  _scaleChanged() {
    scheduleOnce('afterRender', this, this.draw);
  }
  draw() {
    const scale = this.scale;
    const orient = this.orient;
    const outerTickSize = this.outerTickSize;
    const innerTickSize = this.innerTickSize;
    const tickFormat = this.tickFormat;
    const tickPadding = this.tickPadding;
    const tickValues = this.tickValues;
    const ticks = this.ticks;
    const axis = d3.svg.axis().scale(scale);
    if (!isNone(orient)) {
      axis.orient(orient);
    }
    if (!isNone(outerTickSize)) {
      axis.outerTickSize(outerTickSize);
    }
    if (!isNone(innerTickSize)) {
      axis.innerTickSize(innerTickSize);
    }
    if (!isNone(tickPadding)) {
      axis.tickPadding(tickPadding);
    }
    if (!isNone(tickFormat)) {
      axis.tickFormat(tickFormat);
    }
    if (!isNone(tickValues)) {
      axis.tickValues(tickValues);
    }
    if (ticks && ticks.length > 0 && isNone(tickValues)) {
      axis.ticks(...ticks);
    }
    const element = $(this.element) ? $(this.element).get(0) : undefined; // eslint-disable-line ember/no-jquery
    if (isNone(element)) {
      return;
    }
    if (this.transitionDuration !== 0) {
      d3.select(element).transition().duration(this.transitionDuration).ease(this.transitionEase).call(axis);
    } else {
      d3.select(element).call(axis);
    }
    this.adjustTickLength(element);
    this.attemptToRotateTicks(element, this.rotateTicksToFit);
  }
  adjustTickLength(element) {
    const majorInnerTickSize = this.majorInnerTickSize;
    const tickFormat = this.tickFormat;
    const orient = this.orient;
    if (isNone(majorInnerTickSize) || typeof tickFormat !== 'function') {
      return;
    }
    const sign = ['top', 'left'].includes(orient) ? -1 : 1;
    const attrName = ['bottom', 'top'].includes(orient) ? 'y2' : 'x2';
    // grab all the lines which have a label (tickFormat is not falsy)
    d3.select(element).selectAll('.tick line').filter(tickFormat).each(function () {
      d3.select(this).attr(attrName, sign * majorInnerTickSize);
    });
  }
  maxLabelLength(tickElements) {
    let len = 0;
    tickElements.each(function (label) {
      len = Math.max(len, label.length);
    });
    return len;
  }
  rangeSpan() {
    const range = this.scale.range();
    const x1 = range[0];
    const x2 = range[range.length - 1];
    return Math.abs(x2 - x1);
  }
  attemptToRotateTicks(element, rotateOptions = RotateOptions.NEVER) {
    const tickElements = d3.select(element).selectAll('.tick text');
    if (rotateOptions === RotateOptions.NEVER) {
      return;
    }
    if (rotateOptions === RotateOptions.ALWAYS) {
      this._rotateTicks(tickElements);
      return;
    }
    if (rotateOptions === RotateOptions.AUTO) {
      const maxLabelLength = this.maxLabelLength(tickElements);
      const numTicks = tickElements[0].length;
      const spaceForLabels = this.rangeSpan();
      const spacePerLabel = spaceForLabels / numTicks;
      const spacePerCharacter = spacePerLabel / maxLabelLength;
      if (spacePerCharacter < MIN_SPACE_PER_CHAR) {
        this._rotateTicks(tickElements);
      } else {
        this._unRotateTicks(tickElements);
      }
    }
  }
  _rotateTicks(tickElements) {
    return tickElements.attr('transform', 'translate(-12, 0) rotate(-45, 0, 0)').style('text-anchor', 'end');
  }
  _unRotateTicks(tickElements) {
    return tickElements.attr('transform', '').style('text-anchor', 'middle');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "transform", [attribute], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "_scaleChanged", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "_scaleChanged"), _class2.prototype)), _class2)) || _class) || _class);
export { SqChartAxis as default };